const p = "ikp", y = {
  colors: "color",
  fontFamily: "font-family",
  fontSize: "font-size",
  zIndex: "z-index"
};
function r(t) {
  return t.replace(/([A-Z])/g, "-$1").toLowerCase();
}
function g(t) {
  const c = {};
  for (const [o, f] of Object.entries(t)) {
    const l = r(y[o] || o), s = (n, a = []) => {
      if (typeof n != "object" || n === null) {
        const e = a.map(r).join("-");
        return `var(--${p}-${l}-${e})`;
      }
      const i = {};
      for (const [e, u] of Object.entries(n))
        i[r(e)] = s(u, [
          ...a,
          e
        ]);
      return i;
    };
    c[o] = s(f);
  }
  return c;
}
export {
  g as generateThemeVariables,
  y as themeMappings
};
